<div id="layoutHome" class="web-center">
    <div class="col-md-12 adaptiveImgHeight">
        
            <img src="assets/images/Header_How_it_Works_NG.jpg" style="height: 100%; width: 100%; object-fit: cover;" />
            <div class="overlay-banner-Tablet"></div>
             
            <div class="overlay adaptiveImgHeight">
                <div class="textbox">
                    <div>
                        <div>How NutriGenic works</div>
                        <div class="second-line-header-text">Simply Exceptional</div>
                    </div>
                    <div class="header-button">
                        <app-orange-button (action)="goToPlan()" />
                    </div>
                </div>
                
            </div>

           
    </div>
    
    <app-how-it-works></app-how-it-works>
    
    <div class="card-extra pt-40">
        <div class="trustbox">
            <app-reviews />
        </div>
    </div>

    <div class="mt-5">
        <app-help-sector></app-help-sector>
    </div>
</div>
